<template>
  <div id="app">
    <v-app id="inspire">
 <altaciklama ></altaciklama>

      <v-container fluid>
        <v-content>

        <v-layout v-if="listeleme" row wrap>
          <v-flex xs12 sm12 md12>


            <v-layout align-center="" justify-start>
              <v-icon large>people</v-icon>
              <span class=" grey--text headline">{{$t('User-List')}} </span>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm12 md12>
            <v-layout justify-end>
              <v-divider></v-divider>
            </v-layout>
          </v-flex>



          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-list>
                <template>
                  <v-layout row wrap>
                    <v-flex xs3 sm3 md3>
                      <v-layout column="" align-start>
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout align-center>
                                <v-flex>
                                  <v-list-tile-sub-title>
                                    <v-layout column align-center>
                                      {{$t('Name_Surname_label')}} </v-layout>
                                  </v-list-tile-sub-title>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>



                    <v-flex xs4 sm4 md4>
                      <v-layout column="" align-start>
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout align-center>
                                <v-flex>
                                  <v-list-tile-sub-title>
                                    <v-layout column align-center>
                                      {{$t('Email_label')}}
                                    </v-layout>
                                  </v-list-tile-sub-title>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>


                    <v-flex xs3 sm3 md3>
                      <v-layout column="" align-start>
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout align-center>
                                <v-flex>
                                  <v-list-tile-sub-title>
                                    <v-layout column align-center>
                                      {{$t('Mobilphonenumber_label')}}
                                    </v-layout>
                                  </v-list-tile-sub-title>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>


                    <v-flex xs2 sm3 md2>
                      <v-layout justify-end="" align-center>
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout justify-end="" align-center>
                                <v-flex>
                                  <v-list-tile-sub-title>
                                    <v-layout column justify-end="" align-center>
                                      {{$t('Details')}}
                                    </v-layout>
                                  </v-list-tile-sub-title>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>

                  </v-layout>
                  <v-divider></v-divider>
                </template>

                <template v-for="item in sirketitems">
                  <v-layout row wrap v-bind:key="item.id">


                    <v-flex xs3 sm3 md3>
                      <v-layout align-start justify-start="">
                        <v-card flat="">
                          <v-list-tile>
                            <div class="font-weight-thin grey--text body-1">
                              {{item.AdSoyad}}
                            </div>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>


                    <v-flex xs4 sm4 md4>
                      <v-layout column="" align-start>
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout align-center>
                                <v-flex>
                                  <v-list-tile-sub-title>
                                    <v-layout column justify-start="" align-start>
                                      {{item.Email}}
                                    </v-layout>
                                  </v-list-tile-sub-title>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>


                    <v-flex xs3 sm3 md3>
                      <v-layout column="" justify-start="">
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout align-center>
                                <v-flex>
                                  <v-list-tile-sub-title>
                                    <v-layout column align-center>
                                      {{item.GSM}}
                                    </v-layout>
                                  </v-list-tile-sub-title>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>


                    <v-flex xs2 sm2 md2>
                      <v-layout align-end="" justify-end="" fill-height="">
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout>
                                <v-flex xs12 sm4 md3>
                                  <v-btn small icon class="mx-0" @click="detayagit(item)">
                                    <v-icon large="" color="grey">search</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>

                  </v-layout>
                  <v-divider :key="item.id"></v-divider>
                </template>

              </v-list>
            </v-flex>
          </v-layout>

        </v-layout>



        </v-content>

      </v-container>


    <navi v-model="drawer"></navi>


      <v-dialog v-model="dialogyenisirket" persistent max-width="400px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title>{{ $t('New-Parent-Company') }}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-flex pa-1 xs12 sm12 md12>

            <v-layout wrap>
              <div class="flex md12">
                <v-text-field :label="$t('Company-Title')" v-model="yenisirketunvani"></v-text-field>
              </div>
            </v-layout>

          </v-flex>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" v-if="!bekle" flat @click="sirketaciptal()">{{$t('Cancel')}}</v-btn>
            <v-btn color="info" v-if="!bekle" flat @click="yenisirketac()">{{$t("save_button")}}</v-btn>
            <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>



          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <span class="hidden-sm-and-down"> {{ $t('User-Transactions') }} </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="kullaniciAra" label="Kullanıcı Ara" append-icon="search"></v-text-field>
        <v-btn v-if="eklebtn" @click="yenikullaniciekle()" flat> <span class="hidden-sm-and-down"> Kullanıcı Ekle
          </span>
          <v-icon right dark>add_box</v-icon>
        </v-btn>

      </v-toolbar>


      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>

    </v-app>
  </div>

</template>

<script>
  import auth from '../../../../api/auth'
  import navi from "@/components/app/account/navigator.vue"
  import _ from 'underscore'
  import router from '../../../../router'
  import helpers from "@/components/app/customcomp/helpers.js"
  import altaciklama from "@/components/app/account/altaciklama.vue"

  export default {
     data() {
        return {
      sirketitems: [],
      detay: false,
      listeleme: true,
      active: null,
      eklebtn: false,
      kullaniciAra: null,
      yedekyetkililist: [],
      ManageInfo: {
        UserInfo: {
          UserID: null,
          AdSoyad: null,
          KullaniciAdi: null,
          Email: null,
          GSM: null,
          Sifre: null,
          Deleted: false,
        },
        AnaSirketInfo: []
      },

      WebUserAnaSirket: {
        MusteriID: null,
        MusteriKod: null,
        MusteriUnvan: null,
        UserTip: 0,
        Aktif: false,
        Masraf: null,
        Referans: null,
        Bolum: null,
      },

      yetkilist: [],
      yedekresponse: [],
      bekle: false,
      AnaSirketlerWiev: [],
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {},
      giris: true,
      Urunler: false,
      urunlerlist: [],
      active: false,
      sektor: '0',
      uyeliktipi: '0',
      productshow: [],
      odemetipi: false,
      havale: true,
      kredikarti: false,
      odemeekrani: false,
      toplamtutar: 0,
      urunekrani: true,
      musteriid: null,
      dialogyenisirket: false,
      yenisirketunvani: null,
      sirkettipi: '0',
      karttipi: [{
          id: 'M',
          text: 'Master Card'
        },
        {
          id: 'VI',
          text: 'VISA'
        },
        {
          id: 'A',
          text: 'American Express'
        },
      ],
      sonkullanimAy: [{
          id: '01',
          text: '1'
        },
        {
          id: '02',
          text: '2'
        },
        {
          id: '03',
          text: '3'
        },
        {
          id: '04',
          text: '4'
        },
        {
          id: '05',
          text: '5'
        },
        {
          id: '06',
          text: '6'
        },
        {
          id: '07',
          text: '7'
        },
        {
          id: '08',
          text: '8'
        },
        {
          id: '09',
          text: '9'
        },
        {
          id: '10',
          text: '10'
        },
        {
          id: '11',
          text: '11'
        },
        {
          id: '12',
          text: '12'
        }
      ],
      sonkullanimYil: [
        '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015',
        '2016', '2017',
        '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
        '2029', '2030'
      ],
      dictionary: {
        custom: {
          kartno: {
            required: () => this.$t('This-space-cannot-left-blank'),
            min: this.$t('Card-Number-Must-16-Digits')
          },

          selectkarttipi: {
            required: () => this.$t('Please-choose'),
          },
          kartcari: {
            required: () => this.$t('Please-choose'),
          },
          selectsonkullanim: {
            required: () => this.$t('Please-choose'),
          },
          selectsonkullanimyil: {
            required: () => this.$t('Please-choose'),
          },

        }
      },

      itemsnavi: [{
          icon: 'business',
          text: this.$t('Corporate-transactions'),
          to: 'anasirket',
        },
        {
          icon: 'people',
          text: this.$t('Member-Transactions'),
          to: 'login-uye'
        },

      ],
      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,

      UrunKayit: {
        ID: null,
        MusteriInfo: {
          MusteriID: null,
          MusteriKod: null
        },
        UrunInfo: {
          UrunID: null
        },
        UrunAdet: 1,
        BaslangicTarih: null,
        BitisTarih: null,
        Kontor: null,
        KalanKontor: null,
        SatisTarihi: null,
        SatisTutar: 0,
        Aktif: null,
        OdemeOnay: 'false'
      },
      mevcutsirketmi: true,
      yenisirket: false,
      dialog: false,
      items: [{
          icon: 'domain',
          text: this.$t('Corporate-transactions')
        },
        {
          icon: 'contacts',
          text: this.$t('Member-Transactions')
        },
      ],
      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      rules: {
        required: (value) => !!value || this.$t('Mandatory-Areas'),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('Wrong-e-mail')
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: false,
        MusteriBilgi: [],
        OdemeOnay: false,
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      }
    },
    props: {
      source: String
    },
    methods: {

      yenikullaniciekle() {
        var url = '#/uye/yeni'
        window.open(url, '_self')
      },

      detayagit(val) {

        var url = '#/uye/detay/' + val.Email
        window.open(url, '_target')
      },
      logout() {
        auth.logout()
      },

      getDateNow,
      guncelle,
      userlist
    },
    beforeMount: beforeMount,

    components: {
      'navi': navi,
      altaciklama},
    watch: {
      'kullaniciAra': function (value) {
        this.sirketitems = [];

        if (value != null || value != '') {

          this.sirketitems = []
          this.yedekyetkililist.forEach(element => {


            // Ad Soyad için

            var str = element.AdSoyad

            var std = str.indexOf(value)

            var upstd = str.indexOf(value.toLocaleUpperCase('TR'))
            var lowstd = str.indexOf(value.toLowerCase())

            var strUp = str.toLocaleUpperCase('TR')
            var stdUp1 = strUp.indexOf(value)

            var strLow = str.toLowerCase()
            var stdLow2 = strLow.indexOf(value)

            //email

            var stremail = element.Email

            var stdemail = stremail.indexOf(value)
            var upstdemail = stremail.indexOf(value.toLocaleUpperCase('TR'))
            var lowstdemail = stremail.indexOf(value.toLowerCase())
            var strUpemail = stremail.toLocaleUpperCase('TR')
            var stdUp1email = strUpemail.indexOf(value)
            var strLowemail = stremail.toLowerCase()
            var stdLow2email = strLowemail.indexOf(value)
            var strgsm = element.GSM
            var stdgsm = strgsm.indexOf(value)


            if ((std != -1 || upstd != -1 || lowstd != -1 || stdUp1 != -1 || stdLow2 != -1) || (stdemail != -1 ||
                upstdemail != -1 || lowstdemail != -1 || stdUp1email != -1 || stdLow2email != -1) || stdgsm != -1) {




              this.sirketitems.push(element)
            }

          });


        } else {
          this.sirketitems = this.yedekyetkililist
        }

      },

      'uyeliktipi': function (value) {
        if (value == 0) {
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 2)
              this.productshow.push(element)
          });
        } else {

          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 3)
              this.productshow.push(element)
          });

        }
      },

      'UrunKayit.OdemeOnay': function (value) {
        if (value == 'false') {
          this.havale = true;
          this.kredikarti = false;
        } else {

          this.havale = false;
          this.kredikarti = true;

        }
      },
      'sirkettipi': function (value) {
        if (value == '0') {
          this.mevcutsirketmi = true;
          this.yenisirket = false;
          this.dialogyenisirket = false;

        } else {
          this.dialogyenisirket = true;
          this.mevcutsirketmi = false;
          this.yenisirket = true;

        }
      }



    },
    filters: {
      dateformat: function (t) {
        var date = new Date(t);
        var fulldate = date.toLocaleDateString("tr-TR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        return fulldate;
      },
      moneyformat: function (m) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }
    },
  }

  function beforeMount() {



    var response = JSON.parse(window.localStorage.getItem('response'));



    var userparams = {
      Email: response.Email
    }

    this.$http.post(auth.API_URL + 'api/Register/WebUserConnList', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.sirketitems = response.body
      this.yedekyetkililist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      }
    })

    var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    this.eklebtn = helpers.yetkisorgula(null, response2.AnaSirketInfo)
  }

  function guncelle() {}

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function userlist() {

    var response = JSON.parse(window.localStorage.getItem('response'));

    var userparams = {
      Email: response.Email
    }

    this.$http.post(auth.API_URL + 'api/Register/WebUserConnList', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      }
    })






  }



</script>
 <style scoped>

</style>

